import { makeStyles } from 'tss-react/mui';

const useStylesMenuItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  menuItemActive: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
    '& > svg:last-of-type': {
      margin: '0 0 0 auto',
      color: `${theme.palette.secondary.main} !important`,
      paddingLeft: 5,
    },
  },
  menuItemBold: {
    fontWeight: '500 !important',
  },
  menuItemNoWrap: {
    wordWrap: 'break-word',
    whiteSpace: 'normal !important',
  },
  menuItemOffset: {
    paddingLeft: 30,
  },
  menuItemInactive: {
    '&:hover': {
      backgroundColor: 'transparent !important',
      cursor: 'default',
    },
  },
}));

export default useStylesMenuItem;
